export const OrganizationPermissionConstants = {
    USER_MANAGEMENT: 1,
    SIM_MANAGEMENT: 2,
    TICKETING: 3,
    SERVER_HEALTH: 4,
    ORGANIZATION_MANAGEMENT: 5,
    SYSTEM_CONFIGURATION: 6,
    INTEGRATION: 7,
    APPLICATION_LOGS: 8,
    API_LOGS: 9,
    DEVICE_MANAGEMENT: 10,
    APPLICATION_MANAGEMENT: 11,
    NOTIFICATIONS: 12,
    REPLICATION: 13,
    THE_PINGER: 15,
    LOCATION_MANAGEMENT: 16,
    DASHBOARDS: 17,
    IOT: 18,
    CONTACT_US: 19,
    PROJECT_MANAGEMENT: 21,
    COMMS_ENGINE: 24,
  };
  